import { render, staticRenderFns } from "./HyjlHome.vue?vue&type=template&id=4ac023b5&scoped=true"
import script from "./HyjlHome.vue?vue&type=script&lang=js"
export * from "./HyjlHome.vue?vue&type=script&lang=js"
import style0 from "./HyjlHome.vue?vue&type=style&index=0&id=4ac023b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac023b5",
  null
  
)

export default component.exports